import React, { useState, useEffect } from "react";
import DynamicSelectInput, {
  StaticSelectInput,
} from "../../constant/SelectInput";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getDivision } from "../../../services/DocumentService";
import { createAuditApi, getAuditorList } from "../../../services/AuditService";

const AddChecklist = () => {
  const [dataInput, setDataInput] = useState({
    circular_title: "",
    division_id: "",
    auditor_id: "",
    schedule_at: "",
  });
  const [checklist, setChecklist] = useState([
    { checklist_title: "", description: "" },
  ]);
  const [errors, setErrors] = useState({});
  const [division, setDivision] = useState([]);
  const [auditor, setAuditor] = useState([]);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDivision = async () => {
      try {
        const resp = await getDivision();
        setDivision(resp.data.data);
      } catch (error) {
        console.error("Error fetching divisions:", error);
      }
    };

    fetchDivision();
  }, []);

  const fetchAuditor = async (divisionId) => {
    try {
      const resp = await getAuditorList(divisionId);
      setAuditor(resp.data.data);
    } catch (error) {
      console.error("Error fetching auditors:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    setDataInput((prevDataInput) => ({ ...prevDataInput, [name]: value }));
  };

  const handleSelectChange = (name, value) => {
    setDataInput((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "division_id" && { auditor_id: "" }),
    }));

    if (name === "division_id") {
      fetchAuditor(value);
    }
  };

  const handleDynamicChange = (index, field, value) => {
    const updatedFields = [...checklist];
    updatedFields[index][field] = value;
    setChecklist(updatedFields);
  };

  const addDynamicField = () => {
    setChecklist([...checklist, { checklist_title: "", description: "" }]);
  };

  const removeDynamicField = (index) => {
    const updatedFields = [...checklist];
    updatedFields.splice(index, 1);
    setChecklist(updatedFields);
  };

  const validateInputs = () => {
    const validationErrors = {};
    if (!dataInput.circular_title)
      validationErrors.circular_title = "Title is required";
    if (
      checklist.some((field) => !field.checklist_title || !field.description)
    ) {
      validationErrors.checklist = "All fields are required";
    }
    if (!dataInput.division_id)
      validationErrors.division_id = " Division is required";
    if (!dataInput.schedule_at)
      validationErrors.schedule_at = "Schedule date is required";
    return validationErrors;
  };

  const handleSubmit = async () => {
    const validationErrors = validateInputs();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      setIsSubmitLoading(true);
      const payload = {
        ...dataInput,
        checklist,
      };

      const response = await createAuditApi(payload);
      toast.success(response.data.message);
      navigate("/audit");
    } catch (error) {
      toast.error(error.response?.data?.message);
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const handleCancel = () => {
    setDataInput({
      circular_title: "",
      division_id: "",
      auditor_id: "",
      schedule_at: "",
    });
    setChecklist([{ checklist_title: "", description: "" }]);
    setErrors({});
    navigate("/audit");
  };

  return (
    <div className="container-fluid">
      <div className="row px-sm-2 px-0">
        <div className="col-xl-12">
          <div className="card px-sm-3 px-1">
            <div className="card-body">
            <div className="d-flex align-items-center mb-4">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm btn-circle"
                    onClick={() => navigate("/audit")}
                  >
                    <i className="fa-solid fa-arrow-left"></i>
                  </button>
                  <h3 className="mb-0 ms-2">Audit Form</h3>
                </div>
              <div className="row mb-2">
                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      Title<span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      placeholder="Enter Title"
                      name="circular_title"
                      value={dataInput.circular_title}
                      onChange={handleChange}
                    />
                    {errors.circular_title && (
                      <div className="text-danger">{errors.circular_title}</div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <StaticSelectInput
                      optionsList={division.map((item) => ({
                        value: item.id,
                        label: item.name,
                      }))}
                      setParentInputValue={handleSelectChange}
                      name="division_id"
                      value={dataInput.division_id}
                      isClearable
                      placeholder="Select Division"
                      label="Division"
                      isRequired={true}
                    />
                    {errors.division_id && (
                      <div className="text-danger">{errors.division_id}</div>
                    )}
                  </div>
                </div>

                <h5 className="mb-3">
                  CheckList <span className="text-danger">*</span>
                </h5>
                {checklist.map((field, index) => (
                  <div className="row mb-4" key={index}>
                    <div className="col-md-6">
                      <input
                        className="form-control"
                        placeholder="Enter Checklist Title"
                        name="checklist_title"
                        value={field.checklist_title}
                        onChange={(e) =>
                          handleDynamicChange(
                            index,
                            "checklist_title",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-4">
                      <input
                        className="form-control"
                        placeholder="Enter Description"
                        name="description"
                        value={field.description}
                        onChange={(e) =>
                          handleDynamicChange(
                            index,
                            "description",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-2 d-flex align-items-center">
                      {index === checklist.length - 1 && (
                        <button
                          type="button"
                          className="btn btn-success btn-sm me-2"
                          onClick={addDynamicField}
                        >
                          +
                        </button>
                      )}
                      {checklist.length > 1 && (
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={() => removeDynamicField(index)}
                        >
                          -
                        </button>
                      )}
                    </div>
                    {errors.checklist && (
                      <div className="text-danger mb-2 mt-2">
                        {errors.checklist}
                      </div>
                    )}
                  </div>
                ))}
                <h5>Audit Schedule</h5>
                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      Auditor<span className="text-danger">*</span>
                    </label>
                    <StaticSelectInput
                      parentClassName="mb-0 order"
                      optionsList={auditor.map((item) => ({
                        value: item.value,
                        label: item.label,
                      }))}
                      setParentInputValue={handleSelectChange}
                      name={"auditor_id"}
                      id={"auditor_id"}
                      placeholder={"Select Auditor"}
                      value={dataInput.auditor_id}
                      isClearable
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      Schedule At<span className="text-danger">*</span>
                    </label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      name="schedule_at"
                      value={dataInput.schedule_at}
                      onChange={handleChange}
                    />
                    {errors.schedule_at && (
                      <div className="text-danger">{errors.schedule_at}</div>
                    )}
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-start">
                <button
                  type="button"
                  className="btn btn-primary me-3"
                  onClick={() => handleSubmit()}
                  disabled={isSubmitLoading}
                >
                  {isSubmitLoading ? "Submitting..." : "Submit"}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddChecklist;
